import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReportMachine } from '../../../types';
import './MachineInfo.css';

interface MachineInfoProps {
  machine: ReportMachine | Partial<ReportMachine> | null | undefined;
  title?: string;
}

export const MachineInfo: React.FC<MachineInfoProps> = ({ machine, title }) => {
  const { t } = useTranslation();

  if (!machine) {
    return null;
  }

  return (
    <section className="sidebar-section machine-info">
      <h3>{title || t('sidebar.machineInfo')}</h3>
      <div className="sidebar-grid">
        <div className="sidebar-field">
          <label>{t('sidebar.machineNumber')}</label>
          <input type="text" value={machine.idNumber || ''} readOnly className="input-readonly" />
        </div>
        <div className="sidebar-field">
          <label>{t('sidebar.description')}</label>
          <input type="text" value={machine.description || ''} readOnly className="input-readonly" />
        </div>
      </div>
    </section>
  );
};

export default MachineInfo;
